<div class="outlier-selection-comments-wrapper">
    <mat-dialog-actions class="close-icon">
        <img src="assets/images/dialog-close.svg" class="closeStyle" alt="close" (click)=closeFunction();>
    </mat-dialog-actions>
    <div class="dialog-title">
        <span>{{'common.mark_as_outlier' | translate}}</span>
    </div>
    <div class="selected-points-info">
        <div class="count">
            <span>{{selectedPoints?.length ? selectedPoints?.length : 0}}</span>
        </div>
        <span>{{'common.data_points' | translate}}</span>
    </div>
    <div class="comment-wrapper">
        <mat-form-field class="fw spc-form-field" appearance="outline">
            <mat-label>{{'common.comment' | translate}}</mat-label>
            <textarea matInput autocomplete="off" class="description" maxlength="150" required rows="3"
                [(ngModel)]="comment" required></textarea>
        </mat-form-field>
    </div>
    <div class="user-dtls">
        <div class="name">
            <span class="user-name">{{userDtls?.profile?.given_name}}</span>&nbsp;
            <span class="user-name">{{userDtls?.profile?.family_name}}</span>
        </div>
        <div class="icon"></div>
    </div>
    <div class="button-block">
        <button mat-raised-button class="spc-btn" [disabled]="!(selectedPoints?.length && comment?.length)"
            (click)="setOutliers()" color="primary" type="submit">{{'common.mark_as_outlier' | translate}}</button>
    </div>
</div>